import { colorValues } from "@ac-expo/api-types";
import { z } from "zod";
import { fileSchema } from "../files";

const isValidHttpUrl = (value: string) => {
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

export const communicationKitSchema = z
  .object({
    id: z.string().optional(),
    title: z.string(),
    subTitle: z.string(),
    dates: z.string(),
    place: z.string(),
    textColor: z.enum(colorValues),
    filterColor: z.enum(colorValues),
    filterOpacity: z.number().int().max(100).min(0),
    customButton: z.boolean(),
    buttonText: z.string(),
    buttonUrl: z.string(),
    buttonColor: z.enum(colorValues),
    buttonTextColor: z.enum(colorValues),
    backgroundPicture: fileSchema.nullable(),
    logoPicture: fileSchema.nullable(),
    eventId: z.string().nullable(),
  })
  .superRefine((values, ctx) => {
    if (!values.customButton || isValidHttpUrl(values.buttonUrl)) return;

    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["buttonUrl"],
      message: "Le lien doit être une URL valide",
    });
  });

export const defaultCommunicationKitSchemaValues: CommunicationKitForm = {
  title: "",
  subTitle: "",
  dates: "",
  place: "",
  textColor: "white",
  filterColor: "black",
  filterOpacity: 0,
  customButton: false,
  buttonText: "",
  buttonUrl: "",
  buttonColor: "white",
  buttonTextColor: "black",
  backgroundPicture: null,
  logoPicture: null,
  eventId: null,
};

export type CommunicationKitForm = z.infer<typeof communicationKitSchema>;
